import { NgZorroModule } from './../../../../shared/modules/ng-zorro/ng-zorro.module';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from '@angular/core';
import { ListTableComponent } from '../../../../shared/components/list-table/list-table.component';
import { BaseComponent } from '../../../../shared/utils/base.component';
import {
  AbstractControl,
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  ValidationErrors,
} from '@angular/forms';
import { CommonModule, DOCUMENT } from '@angular/common';
import { LeadDetailsService } from '../../../../services/lead-details.service';
import { NzTimePickerModule } from 'ng-zorro-antd/time-picker';
import { performValidation } from '../../../../shared/utils/validation.util';
import { LoggerService } from '../../../../shared/services/logger.service';
import {
  RADIO_YES_NO_OPTIONS,
  STATIC_DATA,
  SHORT_TO_FULL_DAY
} from '../../../../shared/constants/static-data.constants';
import { AuthorizeDirective } from '../../../../shared/authorization/authorize.directive.';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { NotificationService } from '../../../../shared/services/notification.service';
import { ERROR_MESSAGES } from '../../../../shared/constants/error-message.constants';
import { UserService } from '../../../../services/user.service';
import { SectionsService } from '../../../../services/sections.service';
import { LookupService } from "../../../../services/lookup.service";
import { CalendarModule } from 'primeng/calendar';
import { MultiselectComponent } from '../../../../shared/components/multiselect/multiselect.component';
import { DropdownSelectComponent } from '../../../../shared/components/dropdown-select/dropdown-select.component';
import { TimepickerComponent } from '../../../../shared/components/timepicker/timepicker.component';

@Component({
  selector: 'ppl-lead-detail-communication-info',
  standalone: true,
  imports: [
    NgZorroModule,
    CommonModule,
    ListTableComponent,
    FormsModule,
    ReactiveFormsModule,
    NzTimePickerModule,
    CalendarModule,
    AuthorizeDirective,
    ButtonComponent,
    MultiselectComponent,
    DropdownSelectComponent,
    TimepickerComponent
  ],
  templateUrl: './lead-detail-communication-info.component.html',
  styleUrl: './lead-detail-communication-info.component.css',
})
export class LeadDetailCommunicationInfoComponent
  extends BaseComponent
  implements OnInit, OnChanges
{
  preferncesForm!: FormGroup;
  mode = 'read';
  showEdit = true;
  filledInfo!: any;
  contactType: any[] = [];
  languages: any[] = [];
  accommodations: any[] = [];
  steps: any;
  parsedBestTimeToContact: any;
  spokenLanguages: any;
  entry!: string;
  selectedLead: any;
  approvedStatus: string = STATIC_DATA.APPROVED;
  deniedStatus: string = STATIC_DATA.DENIED;
  leadStatus = '';
  shortToFullDayMap: any = SHORT_TO_FULL_DAY;
  formLanguages = [
    {
      lkpValueCode: 'AR',
      lkpValueName: 'Arabic',
    },
    {
      lkpValueCode: 'BN',
      lkpValueName: 'Bangla',
    },
    {
      lkpValueCode: 'CMN',
      lkpValueName: 'Mandarin',
    },
    {
      lkpValueCode: 'EN',
      lkpValueName: 'English',
    },
    {
      lkpValueCode: 'FR',
      lkpValueName: 'French',
    },
    {
      lkpValueCode: 'HT',
      lkpValueName: 'Haitian Creole',
    },
    {
      lkpValueCode: 'IT',
      lkpValueName: 'Italian',
    },
    {
      lkpValueCode: 'JI',
      lkpValueName: 'Yiddish',
    },
    {
      lkpValueCode: 'KO',
      lkpValueName: 'Korean',
    },
    {
      lkpValueCode: 'PL',
      lkpValueName: 'Polish',
    },
    {
      lkpValueCode: 'RU',
      lkpValueName: 'Russian',
    },
    {
      lkpValueCode: 'SP',
      lkpValueName: 'Spanish',
    },
    {
      lkpValueCode: 'UR',
      lkpValueName: 'Urdu',
    },
    {
      lkpValueCode: 'YUE',
      lkpValueName: 'Cantonese',
    },
  ];

  participantRegisterMode: any;

  @Input() set sectionData(data: string) {
    /* console.log(data); */
    this.steps = data;
  }

  @Output() leadUpdated = new EventEmitter<boolean>();
  @Input() pageId = '';
  @Input() tabId = '';
  @Input() programCode  = '';
  @Input() selectedLeadId!: number;
  @Input() readOnly = false;
  @Input() restrictReferralEdit = false;
  radioOptions = RADIO_YES_NO_OPTIONS;

  constructor(private fb: FormBuilder, 
    private logger : LoggerService, private leadDetailsService: LeadDetailsService, private notificationService : NotificationService, private userService: UserService, private sectionService: SectionsService,
    private renderer: Renderer2,
    @Inject(DOCUMENT) private doc: Document) {
    super()
  }

  ngOnInit(): void {
    this.participantRegisterMode = this.getLookup('Participant_Register_Mode');
    this.selectedLead = JSON.parse(this.userService.getSelectedLead()!);
    this.entry = this.userService.getLeadEntry() ?? '';
    this.showEdit = !this.restrictReferralEdit;
    this.leadDetailsService.getLeadStatus().subscribe((status: string) => {
      this.leadStatus = status;
      
    });
    this.getLookupData();
    this.createFormGroup();
    if (this.mode == 'read') {
      this.leadDetailsService.getUpdatedLeadData().subscribe((data) => {
        if (this.entry == STATIC_DATA.PROVIDER_ENROLLMENT) {
          this.filledInfo = data?.responsedata?.communicationPreferences;
        } else {
          this.filledInfo = data?.responsedata?.contactDetailsData;
        }

        if (this.filledInfo && this.filledInfo.bestTimeToContact) {
          this.parsedBestTimeToContact = super.parsePreferredDaysAndTime(
            this.filledInfo.bestTimeToContact
          );
          /* this.logger.debug("this.parsedBestTimeToContact =====>", this.parsedBestTimeToContact ) */
        }

        this.spokenLanguages =
          this.filledInfo && this.filledInfo.spokenLanguages
            ? this.filledInfo.spokenLanguages.map((lang: any) => lang.language)
            : [];
      });
      //this.filledInfo = this.staticData;
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    try {
      if (changes['sectionData'] && changes['sectionData'].currentValue) {
        this.secData = this.steps['contact_detail_comm_preferences'];
      }
    } catch (e) {
      console.log('Error in getting section data and updating latest info', e);
    }
  }

  createFormGroup(): void {
    const formElements: any = {
      leadContactDetailsId: new FormControl(),
      leadId: new FormControl(),
      spokenLanguages: new FormControl(''),
      primaryLanguage: new FormControl(''),
      formLanguage: new FormControl(''),
      otherDetails: new FormControl(''),
      specialAccomdation: new FormControl(''),
      specialAccomdationOther: new FormControl(''),
    };

    if (
      this.entry == STATIC_DATA.PARTICIPANT ||
      this.entry == STATIC_DATA.REFERRAL ||
      this.entry == STATIC_DATA.PARTICIPANT_ENROLLMENT
    ) {
      formElements.daysToContact = this.fb.array(
        this.daysOfWeek.map(() => this.fb.control(false))
      );
      formElements.bestTimeToContact = new FormControl();
      formElements.bestTimeToContactForSave = new FormControl('');
      formElements.startContactTime = new FormControl(null);
      formElements.endContactTime = new FormControl(null);
      formElements.contactType = new FormControl('');
      formElements.contactFirstName = new FormControl('');
      formElements.contactLastName = new FormControl('');
      formElements.contactEmail = new FormControl('');
      formElements.contactPhone = new FormControl('');
      formElements.registerPref = new FormControl('');
    }

    if (
      this.entry == STATIC_DATA.PROVIDER ||
      this.entry == STATIC_DATA.PROVIDER_ENROLLMENT
    ) {
      formElements.availabilityDays = this.fb.array(
        this.daysOfWeek.map(() => this.fb.control(false))
      );
      formElements.availabilityTimingStart = new FormControl(null);
      formElements.availabilityTimingEnd = new FormControl(null);
      formElements.distanceWillingToTravel = new FormControl(null);
      formElements.dayEmergencyAvailablityStart = new FormControl(null, this.dayShiftValidaor.bind(this));
      formElements.dayEmergencyAvailablityEnd = new FormControl(null, this.dayShiftValidaor.bind(this));
      formElements.nightEmergencyAvailablityStart = new FormControl(null, this.nightShiftValidaor.bind(this));
      formElements.nightEmergencyAvailablityEnd = new FormControl(null, this.nightShiftValidaor.bind(this));
      formElements.isAvailableForEmergencies = new FormControl();
      formElements.registerPref = new FormControl('');
    }

    if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT || this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      formElements.emergencyContactFirstName = new FormControl(null);
      formElements.emergencyContactLastName = new FormControl(null);
      formElements.emergencyContactPhone = new FormControl(null);
    }
    if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      formElements.emergencyContactEmail = new FormControl(null);
    }
    if (this.entry === STATIC_DATA.REFERRAL) {
      formElements.registerPref = new FormControl('');
    }

    this.preferncesForm = new FormGroup(formElements);
  }


  // Helper to parse string or Date to Date object
  private parseToDate(val: any): Date | null {
    if (!val) return null;
    if (val instanceof Date) return val;
    if (typeof val === 'string') {
      // Handles "9:00 AM" or "21:00"
      const d = new Date();
      let [timePart, modifier] = val.split(' ');
      let [hours, minutes] = timePart.split(':').map(Number);
      if (modifier && modifier.toLowerCase() === 'pm' && hours < 12) hours += 12;
      if (modifier && modifier.toLowerCase() === 'am' && hours === 12) hours = 0;
      d.setHours(hours, minutes || 0, 0, 0);
      return d;
    }
    return null;
  }

  dayShiftValidaor(control: AbstractControl): ValidationErrors | null {
    const dayShiftStartTime = this.parseToDate(this.preferncesForm?.get('dayEmergencyAvailablityStart')?.value);
    const dayShiftEndTime = this.parseToDate(this.preferncesForm?.get('dayEmergencyAvailablityEnd')?.value);
    if (!dayShiftStartTime && dayShiftEndTime) {
      return { dayStartTimeRequired : true };
    }
    if (dayShiftStartTime && !dayShiftEndTime) {
      return { dayEndTimeRequired : true };
    }
    if (dayShiftStartTime && dayShiftEndTime) {
      if (dayShiftStartTime >= dayShiftEndTime) {
        return { dayShiftTimeInvalid: true };
      }
      const startTimehours = dayShiftStartTime.getHours();
      const endTimehours = dayShiftEndTime.getHours();
      if ((endTimehours == 22 && dayShiftEndTime.getMinutes() > 0) || startTimehours < 6 || startTimehours > 22 || endTimehours < 6 || endTimehours > 22) {
        return { dayShiftInvalid: true };
      }
    }
    this.preferncesForm?.get('dayEmergencyAvailablityStart')?.setErrors(null);
    this.preferncesForm?.get('dayEmergencyAvailablityEnd')?.setErrors(null);
    return null; // No validation errors
  }


  nightShiftValidaor(control: AbstractControl): ValidationErrors | null {
    const nightShiftStartTime = this.parseToDate(this.preferncesForm?.get('nightEmergencyAvailablityStart')?.value);
    const nightShiftEndTime = this.parseToDate(this.preferncesForm?.get('nightEmergencyAvailablityEnd')?.value);
    if (!nightShiftStartTime && nightShiftEndTime) {
      return { nightStartTimeRequired : true };
    }
    if (nightShiftStartTime && !nightShiftEndTime) {
      return { nightEndTimeRequired : true };
    }
    if (nightShiftStartTime && nightShiftEndTime) {
      const startTimehours = nightShiftStartTime.getHours();
      const endTimehours = nightShiftEndTime.getHours();
      if (!((startTimehours > 22 || startTimehours < 6 || (startTimehours == 22 && nightShiftStartTime.getMinutes() == 0))
         && (endTimehours >= 22 || endTimehours < 6 || (endTimehours == 6 && nightShiftEndTime.getMinutes() == 0)))) {
        return { nightShiftInvalid: true };
      }
      // Adjust for night shift crossing midnight
      const updatedNightShiftStartTime = new Date(nightShiftStartTime);
      const updatedNightShiftEndTime = new Date(nightShiftEndTime);
      if (endTimehours <= 6){
        updatedNightShiftEndTime.setDate(updatedNightShiftEndTime.getDate() + 1);
      }

      if (startTimehours <= 6){
        updatedNightShiftStartTime.setDate(updatedNightShiftStartTime.getDate() + 1);
      }
      if (updatedNightShiftStartTime >= updatedNightShiftEndTime) {
        return { nightShiftTimeInvalid: true };
      }
    }

    this.preferncesForm?.get('nightEmergencyAvailablityStart')?.setErrors(null);
    this.preferncesForm?.get('nightEmergencyAvailablityEnd')?.setErrors(null);
    return null; // No validation errors
  }

  getLookupData() {
    this.languages = this.lookupService.getLookupValue('Language');
    this.contactType = this.lookupService.getLookupValue('Contact_Type');
    this.accommodations = this.lookupService.getLookupValue(
      'Special_Accomdation'
    );
  }

  getValue(code: string, valueOf: string) {
    let check;
    if (valueOf == 'lang') {
      check = this.languages;
    } else if (valueOf == 'contact') {
      check = this.contactType;
    } else {
      check = this.accommodations;
    }
    return this.lookupService.getLookupName(check, code);
  }

  editInfo() {
    this.mode = 'edit';
    this.preferncesForm.patchValue(this.filledInfo);

    if (
      this.entry == STATIC_DATA.PROVIDER ||
      this.entry == STATIC_DATA.PROVIDER_ENROLLMENT
    ) {
      let emergencyAvailabilityDay = null;
      let emergencyAvailabilityNight = null;
      /* if(!this.filledInfo?.emergencyAvailabilityDay.includes('NaN')){ */
      emergencyAvailabilityDay = super.getStartAndEndTimes(
        this.filledInfo?.emergencyAvailabilityDay
      );
      /* } */

      /* if(!this.filledInfo?.emergencyAvailabilityNight.includes('NaN')){ */
      emergencyAvailabilityNight = super.getStartAndEndTimes(
        this.filledInfo?.emergencyAvailabilityNight
      );
      /* } */

      this.preferncesForm.patchValue({
        spokenLanguages: this.spokenLanguages,
        isAvailableForEmergencies:
          this.filledInfo?.isAvailableForEmergencies === true ? 'Yes' : 'No',
        availabilityTimingStart: super.getDateTimeFromTime(
          this.parsedBestTimeToContact?.startTime
        ),
        availabilityTimingEnd: super.getDateTimeFromTime(
          this.parsedBestTimeToContact?.endTime
        ),
        availabilityDays: super.getDaysOftheWeek(
          this.parsedBestTimeToContact?.days
        ),

        dayEmergencyAvailablityStart: emergencyAvailabilityDay
          ? emergencyAvailabilityDay?.startTime
          : null,
        dayEmergencyAvailablityEnd: emergencyAvailabilityDay
          ? emergencyAvailabilityDay?.endTime
          : null,
        nightEmergencyAvailablityStart: emergencyAvailabilityNight
          ? emergencyAvailabilityNight?.startTime
          : null,
        nightEmergencyAvailablityEnd: emergencyAvailabilityNight
          ? emergencyAvailabilityNight?.endTime
          : null,
        leadContactDetailsId: this.getContactDetailsId(this.filledInfo),
      });
    }

    if (
      this.entry == STATIC_DATA.PARTICIPANT ||
      this.entry == STATIC_DATA.REFERRAL ||
      this.entry == STATIC_DATA.PARTICIPANT_ENROLLMENT
    ) {
      this.preferncesForm.patchValue({
        spokenLanguages: this.spokenLanguages,
        startContactTime: super.getDateTimeFromTime(
          this.parsedBestTimeToContact?.startTime
        ),
        endContactTime: super.getDateTimeFromTime(
          this.parsedBestTimeToContact?.endTime
        ),
        daysToContact: super.getDaysOftheWeek(
          this.parsedBestTimeToContact?.days
        ),
        leadContactDetailsId: this.getContactDetailsId(this.filledInfo),
      });
    }
  }

  getContactDetailsId(source: any) {
    if (
      this.entry === STATIC_DATA.PARTICIPANT ||
      this.entry === STATIC_DATA.PROVIDER
    ) {
      return source?.leadContactDetailsId;
    } else if (this.entry === STATIC_DATA.REFERRAL) {
      return source?.referralContactDetailsId;
    } else if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      return source?.participantContactDetailsId;
    } else if (this.entry === STATIC_DATA.PROVIDER_ENROLLMENT) {
      return source?.contactDetailsId;
    } else {
      return 0;
    }
  }

  cancelEdit() {
    this.mode = 'read';
    this.preferncesForm.reset();
  }

  save() {
    let payload: any = {};
    const formData = this.preferncesForm.value;
    formData.emergencyContactFirstName =
      formData.emergencyContactFirstName?.trim();
    formData.emergencyContactLastName =
      formData.emergencyContactLastName?.trim();

    if (
      this.entry === STATIC_DATA.PROVIDER ||
      this.entry === STATIC_DATA.PROVIDER_ENROLLMENT
    ) {
      const selectedDays = super.getDaysSelected(formData.availabilityDays);
      formData.availabilityDays = selectedDays;
      /* formData.isAvailableForEmergencies = formData.isAvailableForEmergencies === true ? 'Yes' : 'No'; */
      formData.availabilityTimingStart = super.getTimeFromDate(
        formData.availabilityTimingStart
      );
      formData.availabilityTimingEnd = super.getTimeFromDate(
        formData.availabilityTimingEnd
      );
      formData.dayEmergencyAvailablityStart = super.getTimeFromDate(
        formData.dayEmergencyAvailablityStart
      );
      formData.dayEmergencyAvailablityEnd = super.getTimeFromDate(
        formData.dayEmergencyAvailablityEnd
      );
      formData.nightEmergencyAvailablityStart = super.getTimeFromDate(
        formData.nightEmergencyAvailablityStart
      );
      formData.nightEmergencyAvailablityEnd = super.getTimeFromDate(
        formData.nightEmergencyAvailablityEnd
      );
    } else {
      const selectedDays = super.getDaysSelected(formData.daysToContact);
      formData.daysToContact = selectedDays;
      formData.startContactTime = super.getTimeFromDate(
        formData.startContactTime
      );
      formData.endContactTime = super.getTimeFromDate(formData.endContactTime);
    }

    try{
      this.validationErrors = performValidation(formData, this.secData, 'Save', undefined, undefined, this.sectionService.getFlow(), this.sectionService.getEnrollmentType());
    } catch {
      console.log('Error in validations');
    }

    const formDataNull = this.isFormNotEmpty(formData);
    if (!formDataNull) {
      this.notificationService.error(
        'Error',
        ERROR_MESSAGES.NO_UPDATE_LEAD_COMM_INFO
      );
      return;
    }

    if (Object.keys(this.validationErrors).length === 0 && this.preferncesForm.valid) {
      payload = this.preparePayload(formData);
      //payload.participantContactDetails.spokenLanguages =  payload.participantContactDetails.spokenLanguages.map((lang:string) => ({ language: lang }));

      /* payload.leadId = formData.leadId;
      payload.leadContactDetailsId = formData.leadContactDetailsId; */

      this.leadDetailsService
        .updateLeadCommunicationInfo(payload, this.entry)
        .subscribe({
          next: () => {
            this.logger.info('Communication information saved successfully');
            this.leadUpdated.emit(true);
            this.cancelEdit();
          },
          error: () => {
            this.leadUpdated.emit(true);
            this.cancelEdit();
          },
        });
    }
  }

  excludeDataCheck = [
    'bestTimeToContact',
    'isAvailableForEmergencies',
    'availabilityDays',
  ];

  isFormNotEmpty(formValue: any): boolean {
    const hasNonEmptyFields = Object.keys(formValue).some((key) => {
      if (!this.excludeDataCheck.includes(key)) {
        if (Array.isArray(formValue[key])) {
          // Check if any item in the array is non-empty
          return formValue[key].some((item: any) => {
            if (typeof item === 'boolean' && item) {
              return item;
            }

            return typeof item === 'string' && item && item.trim().length > 0;
          });
        }
        // Check other fields
        if (
          typeof formValue[key] != 'boolean' &&
          typeof formValue[key] !== 'number'
        ) {
          console.log('key', key);
          return formValue[key] && formValue[key].trim() !== '';
        }
      }
    });
    return hasNonEmptyFields;
  }

  getLanguages(): string {
    const languages: string[] = [];
    this.spokenLanguages?.forEach((el: string) => {
      languages.push(super.getLookupValue(this.languages, el));
    });
    return languages.join(', ');
  }

  preparePayload(source: any) {
    let payload: any = {};

    source.isAvailableForEmergencies =
      source.isAvailableForEmergencies == 'Yes' ? true : false;

    const spokenLanguages: any[] = source?.spokenLanguages?.map(
      (lang: string) => ({ language: lang })
    );

    if (this.entry === STATIC_DATA.PARTICIPANT) {
      payload.participantContactDetails = { ...source };
      payload.contactDetailsId = source.leadContactDetailsId;
      payload.participantContactDetails.spokenLanguages = spokenLanguages;
    } else if (this.entry === STATIC_DATA.PROVIDER) {
      payload.providerCommunicationInfo = { ...source };
      payload.providerCommunicationInfo.spokenLanguages = spokenLanguages;
    } else if (this.entry === STATIC_DATA.REFERRAL) {
      payload.referralParticipantContactDetails = { ...source };
      payload.referralParticipantContactDetails.spokenLanguages =
        spokenLanguages;
    } else if (this.entry === STATIC_DATA.PARTICIPANT_ENROLLMENT) {
      payload.participantEnrlContactDetails = { ...source };
      payload.participantEnrlContactDetails.modifiedDate =
        this.filledInfo?.modifiedDate;
      payload.participantContactDetailsId = source.leadContactDetailsId;
      payload.participantEnrlContactDetails.spokenLanguages = spokenLanguages;
    } else {
      payload.providerEnrlContactDetails = { ...source };
      payload.providerEnrlContactDetails.modifiedDate =
        this.filledInfo?.modifiedDate;
      payload.contactDetailsId = source.leadContactDetailsId;
      payload.providerEnrlContactDetails.spokenLanguages = spokenLanguages;
    }

    payload = {
      ...payload,
      id: this.selectedLead,
      programCode: this.programCode,
      contactDetailsId: source.leadContactDetailsId,
    };

    return payload;
  }

  // disabledNightHours = (): number[] => {
  //   return this.dateFormatter.disabledEmergencyHours.night;
  // };

  disabledNightHours: number[] =
    this.dateFormatter.disabledEmergencyHours.night;

  // disabledDayHours = (): number[] => {
  //   return this.dateFormatter.disabledEmergencyHours.day;
  // };

  disabledDayHours: number[] = this.dateFormatter.disabledEmergencyHours.day;
 
}